import React, { Component } from 'react';
import { SHARED_WEB_URL } from './lib/endpoints';

// The shared bundle ships its own jQuery + Bootstrap, React and redux store, so it must execute only
// once per page - one execution per micro-frontend registered Bootstrap's data-api click handlers N
// times (one data-toggle click opened N stacked modal backdrops) and left each widget on its own React copy.
let sharedBundleLoader = null;

const loadSharedBundle = () => {
    if (!sharedBundleLoader) {
        sharedBundleLoader = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = `${SHARED_WEB_URL}/bundle.js`;
            script.onload = resolve;
            script.onerror = (err) => {
                // allow the next mount to retry rather than caching the failure for the whole session
                sharedBundleLoader = null;
                script.remove();
                reject(err);
            };
            document.head.appendChild(script);
        });
    }
    return sharedBundleLoader;
};

class MicroFrontend extends Component {

    componentDidMount() {
        this.handleMountComponent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refresh !== this.props.refresh) {
            this.handleUnmountComponent();
            this.handleMountComponent();
        }
    }

    componentWillUnmount() {
        this.isUnmounted = true;
        this.handleUnmountComponent();
    }

    handleMountComponent = () => {
        loadSharedBundle()
            .then(() => {
                if (!this.isUnmounted) this.renderMicroFrontend();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    handleUnmountComponent = () => {
        const { name } = this.props;
        let containerId = `${name}-container`;
        window[`unmountMicroFE`] && window[`unmountMicroFE`](containerId);
    }

    renderMicroFrontend = () => {
        try {
            const { name, history, data } = this.props;
            let containerId = `${name}-container`;
            window[`renderMicroFE`] && window[`renderMicroFE`](name, containerId, history, data);
        } catch (err) {
            console.log(err);
        }
    };

    render() {
        return <main id={`${this.props.name}-container`} />;
    }
}

export default MicroFrontend;
